import { createContext } from "react";

export const MyContext = createContext([]);

export const editContext = createContext([]);

export const Etlcontext = createContext([]);
